import React, { useEffect } from "react";
import BookingDetails from "../components/ManageBooking/BookingDetails";
import GuestDetails from "../components/ManageBooking/GuestDetails";
import InfoSection from "../components/ManageBooking/InfoSection";
import PersonalisedBanner from "../components/ManageBooking/PersonalisedBanner";
import SupplementsTable from "../components/ManageBooking/SupplementsTable";

const ManageBooking = ({ bookingDetails }) => {
  const [staterooms, setStaterooms] = React.useState([]);

  useEffect(() => {
    let staterooms = bookingDetails.guest_details.map((guest_info) => {
      return guest_info.room_no;
    });
    staterooms = [...new Set(staterooms)];
    setStaterooms(staterooms);
  }, [bookingDetails]);

  return (
    <div>
      <div className="md:w-3/4 mx-auto p-4 md:p-8">
        <div>
          <BookingDetails bookingDetails={bookingDetails} />
        </div>
        <div className="p-4 md:p-8">
          <h1 className="text-2xl uppercase text-mv-darkblue py-2 font-bold">
            guest details & documents
          </h1>
          {staterooms.map((stateroom) => {
            return (
              <>
                <div key={stateroom}>
                  <h2 className="text-lg uppercase text-white py-1 px-2 rounded-md  bg-mv-darkblue font-bold">
                    Stateroom Number: {stateroom}
                  </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full py-6">
                  {bookingDetails?.guest_details?.map((guest_info) => {
                    if (guest_info.room_no !== stateroom) return null;
                    else
                      return (
                        <div
                          className="flex"
                          key={bookingDetails?.guest_details?.id}
                        >
                          <GuestDetails
                            booking_id={bookingDetails.booking_id}
                            guest_info={guest_info}
                          />
                        </div>
                      );
                  })}
                </div>
              </>
            );
          })}

          <SupplementsTable
            supplement_details={bookingDetails.supplement_details}
          />
        </div>
        <div className="p-4 md:p-8">
          <InfoSection />
        </div>
      </div>
      <div className="w-screen">
        <PersonalisedBanner />
      </div>
    </div>
  );
};

export default ManageBooking;
